import React from 'react';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import './css/icons.css';

const theme = createTheme({
    palette: {
        primary: {
            main: '#00ae92',
            contrastText: '#fff',
        },
        secondary: {
            main: '#00ae92',
            contrastText: '#fff',
        },
        background: {
            default: '#f5f5f5',
        },
        text: {
            primary: '#212121',
            secondary: '#757575',
            blue: '#00856f',
        },
        action: {
            active: '#00a389',
            hover: '#f5f5f5',
        },

        yellow: '#f8ac59',
        green: '#1ab394',
        red: '#ed5565',
    },

    typography: {
        useNextVariants: true,
    },

    overrides: {
        MuiTabs: {
            indicator: {
                height: '3px',
            },
        },
        MuiTab: {
            root: {
                fontSize: '14px !important',
                '&:hover': {
                    backgroundColor: ' #f5f5f5',
                },
            },
        },
        MuiExpansionPanel: {
            root: {
                '&$expanded': {
                    marginTop: 0,
                },
            },
        },
        MuiExpansionPanelSummary: {
            content: {
                '&$expanded': {
                    margin: '12px 0',
                },
            },
        },
        MuiFormControl: {
            marginNormal: {
                marginTop: 8,
            },
        },
        MuiInputLabel: {
            outlined: {
                transform: 'translate(14px, 14px) scale(1)',
                '&$marginDense': {
                    transform: 'translate(14px, 14px) scale(1)',
                },
            },
        },
        MuiOutlinedInput: {
            input: {
                padding: '12px 14px',
            },
            inputMarginDense: {
                paddingTop: 12,
                paddingBottom: 12,
            },
        },
    },
});

function withRoot(Component) {
    function WithRoot(props) {
        // MuiThemeProvider makes the theme available down the React tree
        // thanks to React context.
        return (
            <MuiThemeProvider theme={theme}>
                {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
                <CssBaseline />
                <Component {...props} />
            </MuiThemeProvider>
        );
    }

    return WithRoot;
}

export default withRoot;
